import {ChangeDetectionStrategy, Component, DestroyRef, Inject, inject, OnInit} from '@angular/core';
import {SystemCode} from '@helpers/types/models';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AlarisEditPanelService, EditPanelInputData} from '@campaign-portal/components-library';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SystemCodesService } from '../system-codes.service';

@Component({
	selector: 'app-edit-system-code',
	templateUrl: './edit-code.component.html',
	styleUrl: './edit-code.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EditSystemCodeComponent implements OnInit {
	readonly errors: { key: string; value: string }[] = [
		{key: 'required', value: 'gl.errors.required'}];
	readonly code: SystemCode = {
		ID: null,
		Value: null,
		Description: null
	};

	readonly form = new FormGroup({
		Value: new FormControl<string | null>(null,
			{ nonNullable: false, validators: [Validators.required, Validators.maxLength(100)] }),
		Description: new FormControl<string | null>(null,
			{ validators: Validators.maxLength(100) })
	});

	readonly separator = ', ';
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(EditPanelInputData) private readonly inputData: { code?: SystemCode },
		public readonly service: SystemCodesService,
		private readonly editPanel: AlarisEditPanelService
	) {
		if ( this.inputData.code ) {
			this.code = this.inputData.code;
		}
	}

	ngOnInit(): void {
		this.reset();
	}

	reset(): void {
		const code = structuredClone(this.code);
		this.form.reset(code);
	}

	save(): void {
		const code: SystemCode = {
			ID: this.code.ID,
			Value: this.form.controls.Value.value,
			Description: this.form.controls.Description.value
		};
		this.service.update(code)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if (resp?.Success || resp?.CreatedID) {
					this.editPanel.close(true);
				}
			});
	}

	close(): void {
		this.editPanel.close(false);
	}
}
